import { initCampPhotoSliders } from '../../../mobile/camps/show/camp_photo_slider';

const $ = require('jquery');

// Custom
import FunnySadDialog from 'new_design/common/funny-sad-dialog';
import initPopupListeners from 'new_design/desktop/common/popup';
import { campsSliderTnsInit, popupSliderTnsInit } from 'new_design/desktop/common/sliders';

document.addEventListener('DOMContentLoaded', function () {
  let campId = $('.review-list').data('camp');
  let loadMoreBtn = $('.review-list .review-list-btn');
  let showMoreBtn = $('.review-list .show-more-reviews-btn');
  let fetchUrl = `/camps/${campId}/reviews`;
  let itemsCount = parseInt($('.review-list').data('reviews-count'));
  let freshCount = $('.review-list').data('fresh-size');

  showMoreBtn.on('click', () => {
    let reviewsList = document.querySelector('.review-list');
    let hiddenReviews = reviewsList.querySelectorAll('.review-list-item.hidden');
    let hiddenAlignFlexEnd = reviewsList.querySelectorAll('.align-flex-end.hidden');
    let hiddenReviewsCount = hiddenReviews.length;
    hiddenReviews.forEach((review, index) => {
      if (index < freshCount) {
        review.classList.remove('hidden');
      }
    });
    hiddenAlignFlexEnd.forEach((website, index) => {
      if (index < freshCount) {
        website.classList.remove('hidden');
      }
    });
    if (hiddenReviewsCount < freshCount) {
      showMoreBtn.hide();
    }
    if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
  });

  loadMoreBtn.on('click', () => {
    $.ajax({
      url: fetchUrl,
      dataType: 'json',
      data: {
        website_type: window.website_type,
        offset: itemsCount,
        count: freshCount,
      },
      success: (data) => {
        if (data.count > 0) {
          $('.review-list .review-list-btn').before(data.html);
          itemsCount += data.count;
          popupSliderTnsInit();
          campsSliderTnsInit();
          if (!window.isMobileDevice) {
            initPopupListeners();
          }
          initCampPhotoSliders($('.review-list'));
        }
        if (!data.has_more) {
          loadMoreBtn.hide();
        }
        if (window.tabs_slider) window.tabs_slider.updateSliderHeight();
      },
      error: () => {
        FunnySadDialog.createSadDialog(
          'Произошла ошибка.',
          'Попробуйте обновить вкладку браузера или повторите попытку через несколько минут'
        );
      },
    });
  });

  $('.rating-numbers-line').each((i, elem) => {
    let thisLine = $(elem).find($('.rating-numbers-line_numb')),
      thisWidth = thisLine.attr('data-width');

    thisLine.css('width', `${thisWidth}%`);
  });
});
